// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"2":"8ef60747","12":"148fadd8","225":"0bfbd1d5","405":"f1309134","551":"887c562b","908":"09da2b10","922":"53cad529"}[chunkId] + ".js";
};